import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  campoFormulario: {
    marginTop: theme.spacing(2),
  },
  carregando: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  botoesFormulario: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: theme.spacing(2),
    flexWrap: 'wrap',
    width: '100%',
    marginTop: theme.spacing(4),
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column-reverse',
      alignItems: 'stretch',
    },
  },
  botaoContainer: {
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      '& > button': {
        width: '100% !important',
      },
    },
  },
  dadosEspelho: {
    padding: theme.spacing(1),
  },
}))

export default useStyles
